'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _emptyFunction = require('react-utils/emptyFunction');

var _emptyFunction2 = _interopRequireDefault(_emptyFunction);

var _colors = require('HubStyleTokens/colors');

var _sizes = require('HubStyleTokens/sizes');

var _UIIconHolder = require('../icon/UIIconHolder');

var _UIIconHolder2 = _interopRequireDefault(_UIIconHolder);

var _createLazyPropType = require('../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var _memoizeOne = require('react-utils/memoizeOne');

var _memoizeOne2 = _interopRequireDefault(_memoizeOne);

var _LoadingConstants = require('./LoadingConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getSpinnerSize = function getSpinnerSize(sizeName) {
  return _LoadingConstants.SIZE_OPTIONS[sizeName] || _LoadingConstants.SIZE_OPTIONS['small'];
};

var SpinnerOuter = _styledComponents2.default.div.withConfig({
  displayName: 'UILoadingSpinner__SpinnerOuter'
})(['align-items:center;color:', ';display:flex;flex-direction:', ';justify-content:', ';', ';margin:', ';'], function (props) {
  return props.use === 'on-dark' ? _colors.OLAF : 'currentColor';
}, function (props) {
  return props.layout === 'centered' && 'column';
}, function (props) {
  return props.layout === 'centered' && 'center';
}, function (props) {
  return props.grow && 'width: 100%; height: 100%;';
}, function (props) {
  return !props.grow && '8px';
});

var SpinnerInner = _styledComponents2.default.div.withConfig({
  displayName: 'UILoadingSpinner__SpinnerInner'
})(['align-items:center;display:flex;height:', ';justify-content:center;width:', ';'], function (props) {
  return getSpinnerSize(props.size);
}, function (props) {
  return getSpinnerSize(props.size);
});

var SpinnerLabel = _styledComponents2.default.span.withConfig({
  displayName: 'UILoadingSpinner__SpinnerLabel'
})(['margin-top:', ';&:not(:empty){margin-left:', ';margin-right:', ';}'], function (props) {
  return props.layout === 'centered' && _sizes.BASE_ICON_SPACING_X;
}, _sizes.BASE_ICON_SPACING_X, _sizes.BASE_ICON_SPACING_X);

var getClassName = function getClassName(className, use, displayResult) {
  return (0, _classNames2.default)('private-spinner', className, _LoadingConstants.USE_CLASSES[use], {
    'private-spinner--showing-result': displayResult
  });
};

var getIconSize = function getIconSize(longhandSize) {
  return _LoadingConstants.ICON_SIZE_MAP[longhandSize] || _LoadingConstants.ICON_SIZE_MAP['small'];
};

var getIconColor = function getIconColor(use) {
  return _LoadingConstants.ICON_COLOR_MAP[use];
};

var renderIcon = function renderIcon(failed, resultIcon, longhandSize, use) {
  if (failed || !resultIcon) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: 'private-spinner__result' },
    _react2.default.createElement(_UIIconHolder2.default, {
      innerStyles: { lineHeight: 'inherit', verticalAlign: 'middle' },
      name: resultIcon,
      color: getIconColor(use),
      size: getIconSize(longhandSize)
    })
  );
};

var getComputedStyle = function getComputedStyle(style, grow, minHeight) {
  if (minHeight) {
    var computedStyle = _extends({}, style, { minHeight: minHeight });
    if (!grow) computedStyle.height = '1rem';
    return computedStyle;
  }
  return style;
};

var UILoadingSpinner = function (_Component) {
  _inherits(UILoadingSpinner, _Component);

  function UILoadingSpinner(props) {
    _classCallCheck(this, UILoadingSpinner);

    var _this = _possibleConstructorReturn(this, (UILoadingSpinner.__proto__ || Object.getPrototypeOf(UILoadingSpinner)).call(this, props));

    _this.handleDisplayResultFinish = _this.handleDisplayResultFinish.bind(_this);
    _this.getComputedStyle = (0, _memoizeOne2.default)(getComputedStyle);
    _this.state = {
      displayResult: props.showResult
    };
    return _this;
  }

  _createClass(UILoadingSpinner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var showResult = this.props.showResult;

      if (showResult) {
        this.setResultDisplayTimeout();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var showResult = nextProps.showResult;


      if (this.state.displayResult !== showResult) {
        this.setState({
          displayResult: showResult
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevState.displayResult && this.state.displayResult) {
        this.setResultDisplayTimeout();
      } else if (prevState.displayResult && !this.state.displayResult) {
        clearTimeout(this.resultDisplayTimeout);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.resultDisplayTimeout);
    }
  }, {
    key: 'setResultDisplayTimeout',
    value: function setResultDisplayTimeout() {
      var resultAnimationDuration = this.props.resultAnimationDuration;

      clearTimeout(this.resultDisplayTimeout);
      this.resultDisplayTimeout = setTimeout(this.handleDisplayResultFinish, resultAnimationDuration);
    }
  }, {
    key: 'handleDisplayResultFinish',
    value: function handleDisplayResultFinish() {
      var onResultDisplayFinish = this.props.onResultDisplayFinish;

      onResultDisplayFinish();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          failed = _props.failed,
          showResult = _props.showResult,
          __className = _props.className,
          dataLoading = _props['data-loading'],
          grow = _props.grow,
          label = _props.label,
          labelCompletedText = _props.labelCompletedText,
          layout = _props.layout,
          minHeight = _props.minHeight,
          __resultAnimationDuration = _props.resultAnimationDuration,
          resultIcon = _props.resultIcon,
          role = _props.role,
          use = _props.use,
          showLabel = _props.showLabel,
          size = _props.size,
          style = _props.style,
          __onResultDisplayFinish = _props.onResultDisplayFinish,
          rest = _objectWithoutProperties(_props, ['className', 'failed', 'showResult', 'className', 'data-loading', 'grow', 'label', 'labelCompletedText', 'layout', 'minHeight', 'resultAnimationDuration', 'resultIcon', 'role', 'use', 'showLabel', 'size', 'style', 'onResultDisplayFinish']);

      var displayResult = this.state.displayResult;


      var computedLayout = layout || (grow ? 'centered' : 'inline');

      var computedLabelText = displayResult && !failed ? (0, _lazyEval2.default)(labelCompletedText) : (0, _lazyEval2.default)(label);

      var RenderedLabel = showLabel ? SpinnerLabel : 'span';
      var renderedLabelProps = {
        children: computedLabelText
      };
      if (showLabel) {
        renderedLabelProps.layout = computedLayout;
      } else {
        renderedLabelProps.className = 'sr-only';
      }

      var longhandSize = (0, _tshirtSize.toLonghandSize)(size);

      var spinnerSizePx = parseInt(getSpinnerSize(longhandSize), 10);

      return _react2.default.createElement(
        SpinnerOuter,
        _extends({}, rest, {
          className: getClassName(className, use, displayResult),
          style: this.getComputedStyle(style, grow, minHeight),
          'data-loading': dataLoading !== undefined ? dataLoading : !showResult,
          layout: computedLayout,
          grow: grow,
          role: role,
          use: use
        }),
        _react2.default.createElement(
          SpinnerInner,
          { size: longhandSize },
          _react2.default.createElement(
            'div',
            { className: 'private-spinner-wrapper' },
            _react2.default.createElement(
              'svg',
              {
                className: 'private-spinner__ring',
                height: spinnerSizePx,
                viewBox: '0 0 50 50',
                width: spinnerSizePx
              },
              _react2.default.createElement('circle', {
                className: 'private-spinner__ring-background',
                cx: '25',
                cy: '25',
                r: '22.5',
                fill: 'none',
                strokeWidth: '5'
              }),
              _react2.default.createElement('circle', {
                className: 'private-spinner__ring-path',
                cx: '25',
                cy: '25',
                r: '22.5',
                fill: 'none',
                strokeWidth: '5'
              })
            )
          ),
          renderIcon(failed, resultIcon, longhandSize, use)
        ),
        _react2.default.createElement(RenderedLabel, renderedLabelProps)
      );
    }
  }]);

  return UILoadingSpinner;
}(_react.Component);

UILoadingSpinner.displayName = 'UILoadingSpinner';

UILoadingSpinner.propTypes = {
  'data-loading': _react.PropTypes.bool,
  failed: _react.PropTypes.bool,
  showResult: _react.PropTypes.bool,
  label: (0, _createLazyPropType2.default)(_react.PropTypes.node).isRequired,
  labelCompletedText: (0, _createLazyPropType2.default)(_react.PropTypes.node).isRequired,
  layout: _react.PropTypes.oneOf(['inline', 'centered']),
  minHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  grow: _react.PropTypes.bool,
  resultAnimationDuration: _react.PropTypes.number.isRequired,
  resultIcon: _react.PropTypes.string,
  use: _react.PropTypes.oneOf(Object.keys(_LoadingConstants.USE_CLASSES)),
  showLabel: _react.PropTypes.bool.isRequired,
  size: (0, _tshirtSize.propTypeForSizes)(['xs', 'sm', 'md']),
  onResultDisplayFinish: _react.PropTypes.func
};

UILoadingSpinner.defaultProps = {
  failed: false,
  grow: false,
  label: function label() {
    return _I18n2.default.text('ui.UILoadingSpinner.busyText');
  },
  labelCompletedText: function labelCompletedText() {
    return _I18n2.default.text('ui.UILoadingSpinner.completedText');
  },
  showResult: false,
  resultAnimationDuration: 1500,
  resultIcon: 'success',
  role: 'status',
  onResultDisplayFinish: _emptyFunction2.default,
  showLabel: false,
  size: 'small',
  use: 'link'
};

exports.default = UILoadingSpinner;
module.exports = exports['default'];